export const STR = {
  sv: {
    nav: { home: "Hem", reportage: "Reportage", news: "Nyheter", tool: "Verktyg", admin: "Redaktion" },
    hero: {
      title: "Sportfiskevatten – Verktyget som visar vattnet innan du är där.",
      sub: "Isrisk, hotspots, fiskekort, djupkartor, vattenstånd och fiskarter – i hela Norden.",
      cta: "Öppna verktyget",
    },
    featureCards: ["Isrisk", "Fiskehotspots", "FVOF & fiskekort", "Vattenstånd i Norden", "Djupkartor från SMHI", "Fiskarter från GBIF & SLU", "GPS-positionering"],
    marquee: ["Stilla vatten", "Gnistrande natur", "Doft av kåda", "Fiske", "Skapande", "Övrigt"],
    aboutSection: {
      title: "Gränslandet mellan hantverk, natur & nyfikenhet",
      text: "Sportfiskevatten är platsen där jag samlar allt som händer i gränslandet mellan hantverk, natur och nyfikenhet. En loggbok över ett liv nära vatten, med tankar, projekt, turer och upptäckter.",
    },
    categories: {
      fiske: {
        label: "Fiske",
        desc: "Från stilla gryningsmete till kvällens första hugg – reportage från sjö och älv.",
      },
      skapande: {
        label: "Skapande",
        desc: "Trä, kåda och tålamod. Det som växer fram mellan händerna.",
      },
      ovrigt: {
        label: "Övrigt",
        desc: "Allt däremellan – vandringar, tankar och vardagsvildmark.",
      },
    },
    homeNews: { title: "Fiske i Norden – senaste nytt", viewAll: "Visa alla nyheter" },
    homeArticles: { title: "Berättelser från vattnet", cta: "Läs fler reportage" },
    list: {
      overline: "Reportage",
      title: "Berättelser från skog & sjö",
      all: "Alla",
      loading: "Hämtar berättelser ur dimman…",
      emptyTitle: "Här är det ännu tyst som i skogen.",
      emptyBody: "Inga reportage i den här kategorin ännu – men något är på gång vid arbetsbänken eller ute vid vattnet.",
    },
    post: {
      back: "Alla reportage",
      loading: "Vadar ut i berättelsen…",
      notFound: "Det här reportaget verkar ha drivit iväg med strömmen.",
      notFoundBack: "Tillbaka till reportagen",
    },
    share: {
      label: "Dela reportaget",
      instagram: "Instagram-text",
      copyLink: "Kopiera länk",
      copiedCaption: "Text kopierad – klistra in den i ditt Instagram-inlägg",
      copiedLink: "Länk kopierad",
      copyFail: "Kunde inte kopiera",
    },
    news: {
      overline: "Nyheter",
      title: "Fiskenyheter – samlade åt dig",
      intro: "Vi håller koll på fiskenyheter i Norden – Sverige, Norge och Danmark – så att du snabbt hänger med i vad som händer vid vattnen.",
      readMore: "Läs hela hos",
      loading: "Samlar in dagens fiskenyheter…",
      empty: "Inga nyheter just nu – kolla tillbaka lite senare.",
    },
    tool: {
      overline: "Verktyg",
      title: "Vattenanalys",
      intro: "Klicka på en sjö eller älv på kartan – eller sök efter namn – och analysera isrisk, fiskehotspots, fiskekort och vattenstånd.",
      searchPlaceholder: "Sök sjö eller vattendrag…",
      searchButton: "Sök",
      clickHint: "Klicka på ett vatten på kartan",
      selectedWater: "Valt vatten",
      coordinates: "Koordinater",
      lake: "Sjö",
      river: "Vattendrag",
      analyzeIce: "Analysera isrisk",
      hotspots: "Visa fiskehotspots",
      fvof: "Visa FVOF & fiskekort",
      hydro: "Visa vattenstånd/vattenföring",
      demoBadge: "Demo – simulerad analys",
      modelBadge: "Modellbedömning – bygger på SMHI-data",
      modelBadgeMap: "Modellbedömning – bygger på kartdata",
      realBadge: "Riktig data från SMHI",
      svarBadge: "Öppen data – SMHI Svenskt vattenarkiv",
      sluBadge: "Öppen data – SLU NORS (provfiske)",
      gbifBadge: "Öppna observationer – GBIF",
      fishSpecies: "Fiskarter (provfiske)",
      measures: "Åtgärder i vattnet",
      fpi: {
        title: "Fiskproduktionsindex (FPI)",
        toggle: "FPI-karta",
        legendHint: "Beräknade sjöar färgläggs efter produktionspotential så länge FPI-lagret är aktivt – håll musen över ett vatten för delindex.",
        filterLabel: "Visa endast vatten med FPI ≥",
        tooltip: "Fiskproduktionsindex:",
        count: (shown, total) => `Visar ${shown} av ${total} beräknade vatten`,
        parts: {
          bpp: "BPP (bentisk produktion)",
          markbuffert: "Markbuffert",
          ca_index: "Ca-index",
          vattenkemi: "Vattenkemi",
          bottenfauna: "Bottenfauna",
          hydrologi: "Hydrologi",
          djupvariation: "Djupvariation",
          temperaturtyp: "Temperaturtyp",
        },
      },
      measuresLabels: {
        title: "Genomförda åtgärder nära vattnet",
        empty: "Inga registrerade åtgärder hittades inom 20 km från vattnet.",
        outside: "Åtgärdsdata finns bara för svenska vatten.",
        synced: "Data synkad",
      },
      aivBadge: "Öppen data – Åtgärder i vatten (Länsstyrelserna/HaV)",
      stay: "Boenden nära vattnet",
      staysTitle: "Boenden nära vattnet",
      staysLoading: "Letar boenden…",
      staysError: "Kunde inte hämta boenden just nu.",
      kmFrom: "km från vatten",
      book: "Boka boende",
      exampleBadge: "Exempel",
      priceFrom: (p) => `från ${p} kr/natt`,
      stayTypes: { cabin: "Stuga", camping: "Camping", hotel: "Hotell", bnb: "Gästhus", hostel: "Vandrarhem" },
      stayDescs: {
        cabin: "Egen stuga nära vattnet – perfekt för lugna morgnar vid sjön.",
        camping: "Campingplats och stugby med närhet till både vatten och service.",
        hotel: "Hotell med bekvämligheter en kort biltur från vattnet.",
        bnb: "Mysigt gästhus med lokal prägel och hemkänsla.",
        hostel: "Prisvärt vandrarhem för den som spenderar dagarna vid vattnet.",
      },
      providerNames: { booking: "Booking.com", airbnb: "Airbnb", stugknuten: "Stugknuten", camping: "Camping.se", stf: "STF", osm: "OpenStreetMap", inatur: "Inatur.no" },
      osmKinds: { caravan_site: "Ställplats", camp_site: "Campingplats" },
      showOnMap: "Visa i karta",
      visitSite: "Besök webbplats",
      osmDesc: "Registrerad i OpenStreetMap – öppen kartdata, verifiera gärna läget på plats.",
      staysMapHint: "Boendena markeras på kartan när du stänger fönstret.",
      staysEmpty: "Inga STF-boenden hittades inom 60 km – prova sökgenvägarna nedan.",
      moreStays: "Sök fler boenden",
      fishPanel: {
        common: "Vanligaste arterna", count: "st", yearRange: "Provfisken utförda",
        noData: "Inga provfiskedata finns för denna sjö i SLU:s register (NORS) – registret täcker ett urval av svenska sjöar.",
        source: "Källa", note: "Andelarna visar arternas andel av det totala antalet fångade fiskar vid standardiserade provfisken.",
        obs: "obs", gbifNote: "Baserat på rapporterade fiskobservationer i och kring vattnet (GBIF) – inte standardiserade provfisken, så andelarna speglar rapporteringsläget.",
        norsTitle: "Komplement från provfisken", norsCaught: "fångade vid provfisken",
      },
      nveBadge: "Riktig data från NVE (Norge)",
      sykeBadge: "Riktig data från SYKE (Finland)",
      vandaBadge: "Riktig data från VanDa (Danmark)",
      depthMap: "Djupkarta & sjöfakta",
      depthLabels: {
        maxDepth: "Största djup", meanDepth: "Medeldjup", volume: "Volym", area: "Yta",
        elevation: "Höjd över havet", maps: "Djupkartor", mapsAvailable: "nedladdningsbara kartor",
        download: "Ladda ner djupkartor (zip)", noDepth: "Ingen sjö med det namnet hittades i SMHI:s sjöregister.",
        surveyed: "Mätår", source: "Källa", note: "Djupkartorna är historiska skanningar – kontrollera alltid mot aktuella förhållanden.",
        genesis: "Öppna i Genesis Social Map",
        genesisNote: "C-MAP Genesis samlar ekolodskartor (1-fots djupkurvor, vegetation, bottenhårdhet) som fiskare själva spelat in – främst i Nordamerika, tunnare täckning i Norden. Gratis konto krävs för nedladdning.",
      },
      locate: "Min position",
      osmLayer: "Sjömärken & djupkurvor (OpenSeaMap)",
      locating: "Hämtar position…",
      locateError: "Kunde inte hämta din position – tillåt platsdelning i webbläsaren.",
      result: "Resultat",
      history: "Tidigare analyser",
      noHistory: "Inga analyser ännu.",
      searching: "Söker…",
      analysing: "Analyserar…",
      noWater: "Inget vatten hittades här – klicka närmare en sjö eller älv.",
      legend: "Teckenförklaring",
      webBadge: "Öppen webbdata – iFiske.se",
      fkBadge: "Öppen data – Svenska Fiskekartan",
      inaturBadge: "Öppet API – Inatur.no (Norge)",
      noFvof: "Inget FVOF hittades för detta vatten.",
      fvofLabels: {
        rules: "Regler", season: "Säsong", minSize: "Minsta mått", cardTypes: "Fiskekortstyper",
        prices: "Priser", purchase: "Köp fiskekort", sellers: "Lokala försäljare", contact: "Kontakt",
        tips: "Fisketips", source: "Källa", searchIfiske: "Sök på iFiske.se", searchInatur: "Sök på inatur.no", searchFiskekort: "Sök på fiskekort.dk",
        fisketegnNote: "I Danmark krävs alltid det statliga fisketegnet för dig som är 18–65 år – köp det enkelt online innan du fiskar.",
        fiskekartanTitle: "Områden enligt Svenska Fiskekartan",
        inaturTitle: "Kortfiskeområden via Inatur.no",
        dkTitle: "Fiskekort via fiskekort.dk",
        ifiskeTitle: "Fiskekort & tips via iFiske",
        cats: { fvof: "Fiskevårdsområden", other: "Övriga upplåtelser", fjall: "Fjällfiske (statens vatten)", inatur: "Kortfiskeområden (Norge)", dk: "Fiskekort (Danmark)" },
        stateWater: "Statens vatten",
        kmAway: "km bort",
        buyAtIfiske: "Fiskekort på iFiske →",
      },
      hydroLabels: {
        waterLevel: "Vattenstånd", flowRate: "Vattenföring", trend: "Trend", station: "Station",
        levelStation: "Vattenståndsstation", history: "Historik (vattenföring, senaste dygnet)", updated: "Senast uppdaterad", distance: "Avstånd till station",
        archivedStation: "Arkiverad station – mäter inte längre, se datum",
      },
      iceLabels: {
        station: "Mätstation",
        frostgradsdagar: "Frostgradsdagar (FDD)",
        tjocklek: "Uppskattad istjocklek",
        temperatur: "Temperatur",
        vind: "Vind",
        nederbord: "Nederbörd & snö",
        riskzoner: "Riskzoner",
        orsaker: "Orsaker",
        rekommendation: "Rekommendation",
      },
      fishLabels: {
        djupzoner: "Djupzoner", vegetation: "Vegetation", stromfaror: "Strömfåror",
        inlopp_utlopp: "Inlopp & utlopp", rekommenderade: "Rekommenderade platser",
      },
      hs: {
        title: "Hotspot-strukturer",
        types: {
          predator_point: "Skarp udde",
          hump: "Grund / Hump",
          weedline: "Vegetationskant",
          habitat_edge: "Habitat-övergång",
        },
        shoreFilter: "Visa inom",
        shoreUnit: "m från strand",
        allDistances: "alla avstånd",
        scene: (date) => `Satellitunderlag: Sentinel-2, ${date}`,
        partial: "Stor sjö – satellitanalysen täcker den centrala delen",
        noSat: "Ingen molnfri sommarscen hittades – satellitbaserade hotspots saknas för detta vatten",
        disclaimer: "Strukturerna är beslutsstöd från geometri, satellitbild och jordartskarta – inte verifierade fiskeplatser.",
      },
      kindNames: { ice: "Isrisk", fishing: "Hotspots", fvof: "FVOF", hydro: "Vattenstånd", depth: "Djupkarta", fish: "Fiskarter" },
    },
    footer: {
      tagline: "Reportage om fiske, skapande och livet nära vattnet. Dela gärna vidare – det värmer mer än brasan.",
      copyright: "där strömmen bestämmer riktningen",
      cookieSettings: "Cookieinställningar",
    },
    consent: {
      title: "Cookies & statistik",
      body: "Vi använder Google Analytics för att förstå hur Sportfiskevatten används. Ingen statistik skickas utan ditt godkännande – och du kan ändra dig när som helst via Cookieinställningar i sidfoten.",
      accept: "Godkänn",
      decline: "Endast nödvändiga",
    },
  },
  en: {
    nav: { home: "Home", reportage: "Stories", news: "News", tool: "Tool", admin: "Studio" },
    hero: {
      title: "Sportfiskevatten – The tool that shows you the water before you arrive.",
      sub: "Ice risk, hotspots, fishing permits, depth maps, water levels and fish species – across the Nordics.",
      cta: "Open the tool",
    },
    featureCards: ["Ice risk", "Fishing hotspots", "Permits & FVOF", "Water levels in the Nordics", "Depth maps from SMHI", "Fish species from GBIF & SLU", "GPS positioning"],
    marquee: ["Still water", "Glistening nature", "The scent of tar", "Fishing", "Creating", "Other"],
    aboutSection: {
      title: "The borderland between craft, nature & curiosity",
      text: "Sportfiskevatten is where I gather everything that happens in the borderland between craft, nature and curiosity. A logbook of a life close to water, with thoughts, projects, trips and discoveries.",
    },
    categories: {
      fiske: {
        label: "Fishing",
        desc: "From quiet dawn sessions to the evening's first strike – stories from lake and river.",
      },
      skapande: {
        label: "Creating",
        desc: "Wood, tar and patience. What takes shape between the hands.",
      },
      ovrigt: {
        label: "Other",
        desc: "Everything in between – hikes, thoughts and everyday wilderness.",
      },
    },
    homeNews: { title: "Fishing in the Nordics – latest news", viewAll: "View all news" },
    homeArticles: { title: "Stories from the water", cta: "Read more stories" },
    list: {
      overline: "Stories",
      title: "Stories from forest & lake",
      all: "All",
      loading: "Fetching stories from the mist…",
      emptyTitle: "It's still quiet as the forest here.",
      emptyBody: "No stories in this category yet – but something is brewing at the workbench or out on the water.",
    },
    post: {
      back: "All stories",
      loading: "Wading into the story…",
      notFound: "This story seems to have drifted off with the current.",
      notFoundBack: "Back to the stories",
    },
    share: {
      label: "Share this story",
      instagram: "Instagram caption",
      copyLink: "Copy link",
      copiedCaption: "Caption copied – paste it into your Instagram post",
      copiedLink: "Link copied",
      copyFail: "Couldn't copy",
    },
    news: {
      overline: "News",
      title: "Fishing news – gathered for you",
      intro: "We keep an eye on fishing news across the Nordics – Sweden, Norway and Denmark – so you can quickly stay on top of what's happening by the water.",
      readMore: "Read the full story at",
      loading: "Gathering today's fishing news…",
      empty: "No news right now – check back soon.",
    },
    tool: {
      overline: "Tool",
      title: "Water analysis",
      intro: "Click a lake or river on the map – or search by name – and analyse ice risk, fishing hotspots, fishing permits and water levels.",
      searchPlaceholder: "Search for a lake or river…",
      searchButton: "Search",
      clickHint: "Click a body of water on the map",
      selectedWater: "Selected water",
      coordinates: "Coordinates",
      lake: "Lake",
      river: "River",
      analyzeIce: "Analyse ice risk",
      hotspots: "Show fishing hotspots",
      fvof: "Show fishery board & permits",
      hydro: "Show water level/flow",
      demoBadge: "Demo – simulated analysis",
      modelBadge: "Model estimate – based on SMHI data",
      modelBadgeMap: "Model estimate – based on map data",
      realBadge: "Real data from SMHI",
      svarBadge: "Open data – SMHI Swedish water archive",
      sluBadge: "Open data – SLU NORS (test fishing)",
      gbifBadge: "Open observations – GBIF",
      fishSpecies: "Fish species (test fishing)",
      measures: "Water measures",
      fpi: {
        title: "Fish Production Index (FPI)",
        toggle: "FPI layer",
        legendHint: "Computed lakes are coloured by production potential while the FPI layer is active – hover a water for sub-indices.",
        filterLabel: "Show only waters with FPI ≥",
        tooltip: "Fish Production Index:",
        count: (shown, total) => `Showing ${shown} of ${total} computed waters`,
        parts: {
          bpp: "BPP (benthic production)",
          markbuffert: "Soil buffer",
          ca_index: "Ca index",
          vattenkemi: "Water chemistry",
          bottenfauna: "Bottom fauna",
          hydrologi: "Hydrology",
          djupvariation: "Depth variation",
          temperaturtyp: "Temperature type",
        },
      },
      measuresLabels: {
        title: "Completed measures near the water",
        empty: "No registered measures found within 20 km of the water.",
        outside: "Measure data is only available for Swedish waters.",
        synced: "Data synced",
      },
      aivBadge: "Open data – Åtgärder i vatten (County Boards/HaV)",
      stay: "Stays near the water",
      staysTitle: "Stays near the water",
      staysLoading: "Finding stays…",
      staysError: "Could not load stays right now.",
      kmFrom: "km from water",
      book: "Book stay",
      exampleBadge: "Example",
      priceFrom: (p) => `from ${p} SEK/night`,
      stayTypes: { cabin: "Cabin", camping: "Campsite", hotel: "Hotel", bnb: "Guesthouse", hostel: "Hostel" },
      stayDescs: {
        cabin: "Your own cabin close to the water – perfect for quiet mornings by the lake.",
        camping: "Campsite and cabin village close to both water and amenities.",
        hotel: "A comfortable hotel a short drive from the water.",
        bnb: "A cosy guesthouse with local character and a homely feel.",
        hostel: "An affordable hostel for those who spend their days by the water.",
      },
      providerNames: { booking: "Booking.com", airbnb: "Airbnb", stugknuten: "Stugknuten", camping: "Camping.se", stf: "STF", osm: "OpenStreetMap", inatur: "Inatur.no" },
      osmKinds: { caravan_site: "Motorhome pitch", camp_site: "Campsite" },
      showOnMap: "Show on map",
      visitSite: "Visit website",
      osmDesc: "Listed in OpenStreetMap – open map data, do verify the spot on arrival.",
      staysMapHint: "The stays are marked on the map when you close this window.",
      staysEmpty: "No STF stays found within 60 km – try the search shortcuts below.",
      moreStays: "Find more stays",
      fishPanel: {
        common: "Most common species", count: "pcs", yearRange: "Surveys carried out",
        noData: "No test fishing data exists for this lake in the SLU register (NORS) – the register covers a selection of Swedish lakes.",
        source: "Source", note: "The shares show each species' proportion of the total number of fish caught in standardised test fishing.",
        obs: "obs", gbifNote: "Based on reported fish observations in and around the water (GBIF) – not standardised test fishing, so the shares reflect reporting activity.",
        norsTitle: "Test fishing complement", norsCaught: "caught in test fishing",
      },
      nveBadge: "Real data from NVE (Norway)",
      sykeBadge: "Real data from SYKE (Finland)",
      vandaBadge: "Real data from VanDa (Denmark)",
      depthMap: "Depth map & lake facts",
      depthLabels: {
        maxDepth: "Maximum depth", meanDepth: "Mean depth", volume: "Volume", area: "Area",
        elevation: "Elevation above sea level", maps: "Depth maps", mapsAvailable: "downloadable maps",
        download: "Download depth maps (zip)", noDepth: "No lake with that name was found in the SMHI lake register.",
        surveyed: "Survey year", source: "Source", note: "The depth maps are historical scans – always verify against current conditions.",
        genesis: "Open in Genesis Social Map",
        genesisNote: "C-MAP Genesis collects sonar-recorded charts (1-foot contours, vegetation, bottom hardness) contributed by anglers – mainly North America, thinner coverage in the Nordics. A free account is required for downloads.",
      },
      locate: "My location",
      osmLayer: "Sea marks & depth contours (OpenSeaMap)",
      locating: "Locating…",
      locateError: "Could not get your position – allow location access in your browser.",
      result: "Result",
      history: "Previous analyses",
      noHistory: "No analyses yet.",
      searching: "Searching…",
      analysing: "Analysing…",
      noWater: "No water found here – click closer to a lake or river.",
      legend: "Legend",
      webBadge: "Open web data – iFiske.se",
      fkBadge: "Open data – Svenska Fiskekartan",
      inaturBadge: "Open API – Inatur.no (Norway)",
      noFvof: "No fishery board found for this water.",
      fvofLabels: {
        rules: "Rules", season: "Season", minSize: "Minimum size", cardTypes: "Permit types",
        prices: "Prices", purchase: "Buy a permit", sellers: "Local sellers", contact: "Contact",
        tips: "Fishing tips", source: "Source", searchIfiske: "Search iFiske.se", searchInatur: "Search inatur.no", searchFiskekort: "Search fiskekort.dk",
        fisketegnNote: "In Denmark, the national fisketegn licence is always required if you are 18–65 years old – buy it easily online before fishing.",
        fiskekartanTitle: "Areas from Svenska Fiskekartan",
        inaturTitle: "Permit areas via Inatur.no",
        dkTitle: "Permits via fiskekort.dk",
        ifiskeTitle: "Permits & tips via iFiske",
        cats: { fvof: "Fishery conservation areas", other: "Other licence areas", fjall: "Mountain fishing (state waters)", inatur: "Permit areas (Norway)", dk: "Fishing permits (Denmark)" },
        stateWater: "State-owned water",
        kmAway: "km away",
        buyAtIfiske: "Permit on iFiske →",
      },
      hydroLabels: {
        waterLevel: "Water level", flowRate: "Flow rate", trend: "Trend", station: "Station",
        levelStation: "Level station", history: "History (flow, last day)", updated: "Last updated", distance: "Distance to station",
        archivedStation: "Archived station – no longer measuring, check date",
      },
      iceLabels: {
        station: "Weather station",
        frostgradsdagar: "Freezing degree days (FDD)",
        tjocklek: "Estimated ice thickness",
        temperatur: "Temperature",
        vind: "Wind",
        nederbord: "Precipitation & snow",
        riskzoner: "Risk zones",
        orsaker: "Causes",
        rekommendation: "Recommendation",
      },
      fishLabels: {
        djupzoner: "Depth zones", vegetation: "Vegetation", stromfaror: "Current channels",
        inlopp_utlopp: "Inlets & outlets", rekommenderade: "Recommended spots",
      },
      hs: {
        title: "Hotspot structures",
        types: {
          predator_point: "Sharp point",
          hump: "Shallow / Hump",
          weedline: "Weedline",
          habitat_edge: "Habitat edge",
        },
        shoreFilter: "Show within",
        shoreUnit: "m from shore",
        allDistances: "any distance",
        scene: (date) => `Satellite source: Sentinel-2, ${date}`,
        partial: "Large lake – the satellite analysis covers the central part",
        noSat: "No cloud-free summer scene found – satellite-based hotspots are missing for this water",
        disclaimer: "The structures are decision support from geometry, satellite imagery and soil maps – not verified fishing spots.",
      },
      kindNames: { ice: "Ice risk", fishing: "Hotspots", fvof: "Permits", hydro: "Water level", depth: "Depth map", fish: "Fish species" },
    },
    footer: {
      tagline: "Stories about fishing, making and life close to the water. Feel free to share – it warms more than the fire.",
      copyright: "where the current decides the direction",
      cookieSettings: "Cookie settings",
    },
    consent: {
      title: "Cookies & analytics",
      body: "We use Google Analytics to understand how Sportfiskevatten is used. No statistics are sent without your consent – you can change your mind anytime via Cookie settings in the footer.",
      accept: "Accept",
      decline: "Essential only",
    },
  },
};
